import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not send reset link.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-10 md:py-16 px-4">
      <div className="w-full max-w-md border border-[#E5E7EB] bg-white p-6 sm:p-8" data-testid="forgot-password-page">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-[0.18em] text-[#737373] hover:text-[#0A0A0A]">
          <ArrowLeft size={12} weight="bold" /> Back to sign in
        </Link>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.22em] text-[#002FA7]">Forgot password</p>
        <h1 className="mt-1 font-display text-3xl font-black tracking-tight">Reset your password</h1>

        {sent ? (
          <div className="mt-6 border border-[#D1FAE5] bg-[#ECFDF5] p-5 text-sm" data-testid="forgot-password-sent">
            <p className="font-semibold text-[#065F46]">Check your inbox.</p>
            <p className="mt-1 text-[#065F46]/80">If an account exists for <strong>{email}</strong>, we've sent a reset link. It expires in 60 minutes.</p>
            <Link to="/login" className="btn-secondary mt-5 inline-flex">Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 flex flex-col gap-4" data-testid="forgot-password-form">
            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-semibold">Email</label>
              <input
                type="email"
                required
                autoFocus
                className="input-line"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                data-testid="forgot-email-input"
              />
            </div>
            <button type="submit" disabled={submitting} className="btn-primary justify-center" data-testid="forgot-submit">
              {submitting ? "Sending…" : "Send reset link"}
            </button>
            <p className="text-xs text-[#737373]">We'll email you a link. Social sign-in accounts manage passwords with their provider.</p>
          </form>
        )}
      </div>
    </div>
  );
}
